import { CATEGORY_META } from "../deviceCategories";
import type { AppCircuitRows } from "./types";

export const appCircuitRows: AppCircuitRows = ({ circuits, lengthsByCircuit, categoryName }) =>
  Object.entries(circuits).map(([circuitId, circuit]) => {
    const meta = CATEGORY_META[circuit.category];
    return {
      item: circuitId,
      text: categoryName(circuit.category),
      quantity: lengthsByCircuit?.[circuitId] ?? 0,
      unit: "m",
      cable_type: meta.defaultCableType,
      board: circuit.sourceLabel,
      circuit: circuitId,
      system: meta.system,
    };
  });
